const EpiappClientEvent = require('./EpiappClientEvent')

class EpiappClientResolveEvent extends EpiappClientEvent {
    constructor (props) {
        super(props)

        this.type = EpiappClientResolveEvent.TYPE

        this.launchQuery = props.launchQuery
        this.launchOriginalQuery = props.launchOriginalQuery

        this.resolutionTotalLinkCount = props.resolutionTotalLinkCount
        this.resolutionRootsLinkCount = props.resolutionRootsLinkCount
        this.resolutionAccountsLinkCount = props.resolutionAccountsLinkCount
        this.resolutionLocalDocumentLinkCount = props.resolutionLocalDocumentLinkCount
        this.resolutionLocalApplicationLinkCount = props.resolutionLocalApplicationLinkCount
        this.resolutionWebLinkSearchResultCount = props.resolutionWebLinkSearchResultCount
        this.resolutionAppResultCount = props.resolutionAppResultCount
        this.resolutionWebSearchEngineResultCount = props.resolutionWebSearchEngineResultCount
        this.resolutionDefaultWebSearchEngineResultCount = props.resolutionDefaultWebSearchEngineResultCount

    }
}

EpiappClientResolveEvent.TYPE = 'epi:epiapp:client:resolve:event'

module.exports = EpiappClientResolveEvent
